// extracted by mini-css-extract-plugin
export default {"taskPath":"TaskSelect_taskPath__QFAt0","breadcrumb":"TaskSelect_breadcrumb__hbsvJ","taskCollapse":"TaskSelect_taskCollapse__R3yvS"};